export default __webpack_public_path__ + "00fa33c462fb5b2ba95aa1ca5e16d5e7.png";